module.exports = __webpack_public_path__ + "img/blue_bay_kitchen.5c562ee0.jpeg";